import i18n from 'i18next';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentLocationTypes } from '../../hooks';

export const ShipmentLocationTypesSelect = ({
  placeholder = i18n.t('translation:default.fields.locationType.placeholder'),
  label = i18n.t('translation:default.fields.locationType.label'),
  rules = [],
  name,
  editMode,
  tooltip,
  margin = 'mb-0',
}) => {
  const { data: options = [], isLoading } = useGetShipmentLocationTypes();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      tooltip={tooltip}
    />
  );
};
